import { SEOHead } from "@/components/SEOHead";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";

const Specials = () => {
  return (
    <div className="min-h-screen">
      <SEOHead
        title="Deals & Specials | Son's Guadalupe River Cabanas & Tubing"
        description="Save on Guadalupe River cabanas, tubing & glamping with current specials and promo codes. Limited-time discounts on family-friendly river fun in New Braunfels, TX."
        canonical="/specials"
      />
      <Header />
      <main className="pt-24">
        <section className="section-padding bg-background">
          <div className="container-narrow mx-auto text-center">
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground mb-6">
              Deals & Specials
            </h1>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Check back for current specials and promo codes on Guadalupe River cabanas, tubing & glamping.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Specials;
